import * as actionsType from './../actions/types.js';


export default function authReducer(state = null,action){
  switch(action.type) {
    case actionsType.FETCH_USER: return action.user || false
    // case actionsType.CHANGE_LANGUAGE:{
    //   return ({...state,auth:{...state.auth,language:action.languageIndex} });
    // }
    default: return state;
  }
}
